import { BatchActions } from './BatchActions'
import { ComposeConversation } from './ComposeConversation'
import { ConversationListDataTool } from './ConversationListDataTool'

// New-conversation and the selection-conditional batch writes share the toolbar's
// `other` slot, so the bar stays a single row — the search input never stretches full width.
const Other = () => {
  return (
    <>
      <ComposeConversation />
      <BatchActions />
    </>
  )
}

export const InboxToolbox = () => {
  return <ConversationListDataTool components={{ other: Other }} />
}
